import { MapViewport } from '../../search-history/search-history.model';
import { MapSearchResult } from '../../models/map-listing.model';
import { PolygonFilter } from '../../models/polygon-filter.model';
import { AdReport, ReportSearch } from '../../models/ad-report.model';
import { Car, CarSearchResult } from '../../models/car-model';
import { CarSearch } from '../../models/car-search.model';

export interface CarSortState {
  active: 'createdAt' | 'price' | 'kilometers' | 'performance' | 'year' | null;
  direction: 'asc' | 'desc' | null;
}

export interface PaginationState {
  pageIndex: number;
  pageSize: number;
}

export interface CarState {
  hasSearched: boolean;
  historyRestored: boolean;
  searchRestoreRevision: number;
  mapViewport?: MapViewport;
  listLoading: boolean;
  mapLoading: boolean;
  listError: string | null;
  mapError: string | null;
  listDraft: CarSearch | undefined;
  mapDraft: CarSearch | undefined;
  mapPagination: PaginationState;
  mapSort: CarSortState;
  activePolygon: PolygonFilter | null;
  polygonRevision: number;
  query: CarSearch | undefined;
  mapQuery: CarSearch | undefined;
  carResults: CarSearchResult | undefined;
  carMapResults: MapSearchResult | undefined;
  reportQuery: ReportSearch | undefined;
  carReports: AdReport[] | undefined;
  topCarResults: CarSearchResult | undefined;
  car: Car | undefined;
  loading: boolean;
  topLoading: boolean;
  isSaving: boolean;
  error: string | null;
  sort: CarSortState;
  pagination: PaginationState;
  isCarMapView: boolean;
}

export const initialCarState: CarState = {
  hasSearched: false,
  historyRestored: false,
  searchRestoreRevision: 0,
  mapViewport: undefined,
  listLoading: false, mapLoading: false, listError: null, mapError: null,
  listDraft: undefined, mapDraft: undefined,
  mapPagination: { pageIndex: 0, pageSize: 12 }, mapSort: { active: null, direction: null },
  activePolygon: null,
  polygonRevision: 0,
  query: undefined,
  mapQuery: undefined,
  reportQuery: undefined,
  carResults: undefined,
  carMapResults: undefined,
  carReports: undefined,
  topCarResults: undefined,
  car: undefined,
  loading: false,
  topLoading: false,
  isSaving: false,
  error: null,
  sort: {
    active: null,
    direction: null,
  },
  pagination: {
    pageIndex: 0,
    pageSize: 12,
  },
  isCarMapView: false,
};
